.Thumbnail.Thumbnail {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;
    opacity: 1;
    transition: opacity 0.3s;
}

.VideoContainer {
    width: 100%;
    height: 212px;
    display: block;
    margin: 0 auto;
    position: relative;
}

.ControlButton {
    border-color: transparent transparent transparent var(--color-primary-dark);
    border-style: double;
    border-width: 0 0 0 60px;
    box-sizing: border-box;
    cursor: pointer;
    display: block;
    height: 74px;
    position: absolute;
    transform: scale(0.25);
    transition: 100ms all ease;
    width: 0;

    &.Paused {
        border-style: solid;
        border-width: 37px 0 37px 60px;
        transform: translateX(2px) scale(0.25);
    }
}
